import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import '../templates/base.scss'
import Layout from '../components/Layout/Layout'
import SEO from '../components/SEO'
import CybersecurityContent from '../components/Cybersecurity/CybersecurityContent/CybersecurityContent'
import CybersecurityHero from '../components/Cybersecurity/CybersecurityHero/CybersecurityHero'

const Cybersecurity = ({ data }) => {
  const postNode = {
    title: `Cybersecurity - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <SEO postNode={postNode} pagePath="cybersecurity" customTitle />
      <Helmet>
        <title>{`Cybersecurity - ${config.siteTitle}`}</title>
      </Helmet>
      <CybersecurityHero />
      <CybersecurityContent />
    </Layout>
  )
}

export default Cybersecurity
